import { render, staticRenderFns } from "./ChildModal.vue?vue&type=template&id=1406d3bd&scoped=true&"
import script from "./ChildModal.vue?vue&type=script&lang=js&"
export * from "./ChildModal.vue?vue&type=script&lang=js&"
import style0 from "./ChildModal.vue?vue&type=style&index=0&id=1406d3bd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406d3bd",
  null
  
)

export default component.exports